"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _blue = _interopRequireDefault(require("@material-ui/core/colors/blue"));

var _red = _interopRequireDefault(require("@material-ui/core/colors/red"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const darkTheme = (0, _styles.createMuiTheme)({
  typography: {
    fontFamily: "Akkurat, sans-serif !important"
  },
  palette: {
    type: "dark",
    code: {
      string: _red.default['A100'],
      boolean: _blue.default['A100'],
      number: _blue.default['A100']
    }
  }
});
var _default = darkTheme;
exports.default = _default;
module.exports = exports.default;